<template>
	<div class="radio-group">
		<div class="radio-wrapper">
			<div class="radio-item" v-for="rg in radioGroup">
				<input type="radio"
				       :id="rg.id"
				       :name="rg.name"
				       :value="rg.value"
				       v-model="selected"
				       @click="selectedRadio(rg.value)"
				/>
				<label :for="rg.id">{{ rg.title }}</label>
			</div>
		</div>
	</div>
</template>

<script>

// props radioGroup example
// data: [
// {
// 	title: "",
// 	name: "",
// 	value: "",
// 	id: "",
// }
// ]

export default {
	name: "SOInputRadioBig",
	props: ["radioGroup", "radioSelected"],
	data() {
		return {
			selected: "",
		}
	},
	watch: {
		radioSelected(newVal) {
			this.selected = newVal
		},
	},
	mounted() {
		this.selected = this.radioSelected
	},
	watch: {
		radioSelected(val) {
			this.selected = val
		}
	},
	methods: {
		selectedRadio(value) {
			this.$emit("selected-radio", value)
		}
	}
}
</script>